import axios from './axios.service'

const method = 'dashboard'

class DashboardService {
  async index() {
    try {
      const response = await axios.get(`/${method}`)
      return response.data
    } catch (error) {
      return error
    }
  }
}

export default new DashboardService()
